import React from "react";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { DataResult } from "@progress/kendo-data-query";
import ColumnInfo from "../../interfaces/ColumnInfo";

const exportToExcel = (
  data: DataResult,
  exportObject: ExcelExport,
  columns: ColumnInfo[]
) => {
  const exportColumns = columns.map((column) => {
    const cellOptions = {
      format: column.exportFormat,
    };
    return (
      <ExcelExportColumn
        field={column.field}
        title={column.title}
        cellOptions={cellOptions}
        width={column.width}
      />
    );
  });

  exportObject.save(data, exportColumns);
};

export default exportToExcel;
